"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotSpinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var bounce = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%,\t100% {transform: scale(0)}\n\t50% {transform: scale(1)}\n"], ["\n  0%,\t100% {transform: scale(0)}\n\t50% {transform: scale(1)}\n"])));
var Spot = styled_components_1.default.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #333;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: ", " 2s infinite ease-in-out;\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #333;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: ", " 2s infinite ease-in-out;\n"])), bounce);
var SpotSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '2em' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c;
    var className = "bg-" + color;
    var styles = {
        height: size,
        width: size,
        position: 'relative',
        display: 'inline-block',
    };
    return (jsx_runtime_1.jsxs("i", __assign({ style: __assign({}, styles) }, { children: [jsx_runtime_1.jsx(Spot, { className: className }, void 0),
            jsx_runtime_1.jsx(Spot, { className: className, style: { animationDelay: '-1s' } }, void 0)] }), void 0));
};
exports.SpotSpinner = SpotSpinner;
var templateObject_1, templateObject_2;
//# sourceMappingURL=SpotSpinner.js.map